/*  JS to send allocation requests through the button #notify-commercial-agent in cart page
    Added by Wilson from Galadrim
*/

document.addEventListener("DOMContentLoaded", () => {
  window.initAlloc();
});

document.addEventListener("cart:updated", () => {
  setTimeout(() => {
    window.initAlloc();
  }, 1000);
});

window.initAlloc = () => {
  const btn = document.querySelector("#notify-commercial-agent");
  const notification = document.querySelector("#notify-commercial-agent-notification");
  if (!btn) return;

  const storageKey = "allocationRequestSent";

  const getCurrentAllocatedItems = () => {
    const items = {};
    const allocatedItemsElements = document.querySelectorAll(".allocated-products-section [data-cart-item-key]");
    allocatedItemsElements.forEach(itemEl => {
      const itemKey = itemEl.dataset.cartItemKey;
      const quantityInput = itemEl.querySelector('input[name^="updates"]');
      if (itemKey && quantityInput) {
        items[itemKey] = parseInt(quantityInput.value, 10);
      }
    });
    return items;
  };

  const getStoredData = () => {
    const storedData = localStorage.getItem(storageKey);
    return storedData ? JSON.parse(storedData) : {};
  };

  const updateButtonState = (options = {}) => {
    const { keysJustSent = [] } = options;
    const cartAllocationDataEl = document.querySelector("[data-cart-items-allocation-data]");
    const cartAllocationData = cartAllocationDataEl ? JSON.parse(cartAllocationDataEl.textContent) : [];

    const allocationDataMap = cartAllocationData.reduce((acc, item) => {
      acc[item.key] = item;
      return acc;
    }, {});

    const currentItems = getCurrentAllocatedItems();
    let storedItems = getStoredData();
    const currentKeys = Object.keys(currentItems);
    const storedKeys = Object.keys(storedItems);

    // Clean up stored items that are no longer in the allocation section.
    // This happens when an allocation is approved.
    const newStoredItems = { ...storedItems };
    let storageWasUpdated = false;
    for (const key of storedKeys) {
      if (!Object.prototype.hasOwnProperty.call(currentItems, key)) {
        delete newStoredItems[key];
        storageWasUpdated = true;
      }
    }

    if (storageWasUpdated) {
      localStorage.setItem(storageKey, JSON.stringify(newStoredItems));
      storedItems = newStoredItems; // Use the cleaned data for the rest of the function.
    }

    if (currentKeys.length === 0) {
      btn.disabled = true;
      btn.classList.add("disabled");
      if (notification) notification.style.display = "block";
      return;
    }

    let shouldBeEnabled = false;
    for (const key of currentKeys) {
      // If a request for this item was just sent, it cannot be the reason to re-enable the button.
      if (keysJustSent.includes(key)) {
        continue;
      }

      const itemAllocationInfo = allocationDataMap[key];
      const originallyAsked = itemAllocationInfo ? itemAllocationInfo.originally_asked_quantity : 0;
      const lastRequestSent = Object.prototype.hasOwnProperty.call(storedItems, key);
      const currentQty = currentItems[key];
      const lastRequestedQty = lastRequestSent ? storedItems[key] : 0;

      // Enable if:
      // 1. No request has ever been sent for this item (it's new to the allocation section).
      // 2. An admin has reset the request by setting `originallyAskedQuantity` to 0.
      // 3. The user has increased the quantity since the last request.
      if (!lastRequestSent || (lastRequestSent && originallyAsked === 0) || currentQty > lastRequestedQty) {
        shouldBeEnabled = true;
        break;
      }
    }

    btn.disabled = !shouldBeEnabled;
    if (btn.disabled) {
      btn.classList.add("disabled");
      if (notification) notification.style.display = "block";
    } else {
      btn.classList.remove("disabled");
      if (notification) notification.style.display = "none";
    }
  };

  // --- Watch for cart changes and update button state ---
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const p = origFetch.apply(this, args);
    const [input] = args;
    const url = typeof input === "string" ? input : input.url;

    if (/\/cart\/(add|change|update)\.js/.test(url)) {
      p.finally(() => {
        // Use a timeout to allow the DOM to update after the fetch call.
        setTimeout(updateButtonState, 250);
      });
    }
    return p;
  };

  // Set initial state on page load
  updateButtonState();

  // --- Original click handler logic ---

  btn.addEventListener("click", async () => {
    if (btn.disabled) return;

    // Check that the API is available at the time of click
    if (!window?.Shopify?.custom?.api?.allocationRequest) {
      alert("Erreur : L'API d'allocation n'est pas disponible. Veuillez vous reconnecter.");
      return;
    }

    const itemsToValidate = Array.from(
      document.querySelectorAll('.allocated-products-section [data-cart-item][data-needs-allocation="true"]')
    ).map(node => ({
      productId: node.dataset.productId,
      quantity: Number(node.dataset.quantity),
    }));

    if (itemsToValidate.length === 0) return alert("Aucun article à valider.");

    btn.disabled = true;
    btn.textContent = "Envoi en cours…";

    const currentItemsForStorage = getCurrentAllocatedItems();
    const keysSent = Object.keys(currentItemsForStorage);

    try {
      const res = await window.Shopify.custom.api.allocationRequest.create(itemsToValidate);
      if (!res.ok) throw new Error(await res.text());

      // On success, store the state and disable the button.
      localStorage.setItem(storageKey, JSON.stringify(currentItemsForStorage));

      alert("Demande transmise ! Vous recevrez une réponse sous 48 h.");

      btn.classList.add("disabled");
    } catch (e) {
      console.error(e);
      alert("Erreur lors de l'envoi. Veuillez réessayer.");
      // On error, clear storage to allow retry.
      localStorage.removeItem(storageKey);
    } finally {
      // Always restore button text and update state.
      btn.textContent = "Envoyer ma demande d'allocation";
      updateButtonState({ keysJustSent: keysSent });
    }
  });
};
